<!-- 通过车牌和时间获取VIP信息 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "carCode":"粤B81327",
                "enterTime" : "2018-06-01 09:27:16",
                "parkCode" : "2KKN6112",
                "channelId": 57
            },
            responseCode: {
                "data": {
                "carCode": "string",
                "channelIdList": [
                    0
                ],
                "customVipName": "string",
                "dynamicCarportNumber": 0,
                "id": 0,
                "isDynamicMode": 0,
                "isPureTimeVip": 0,
                "monthTicketBillId": 0,
                "noVipCode": 0,
                "openVipFullLimit": 0,
                "remainDays": 0,
                "timeperiodType": 0,
                "vipBillIsRemainCarport": 0,
                "vipFullOpenModel": 0,
                "vipType": 0,
                "vipTypeIsRemainCarport": 0
                },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            },
            infoData: {
                explain: "通过车牌和时间获取VIP信息",
                t_url: this.commonUrls.test+"getVipByCarNoAndTime",
                p_url: this.commonUrls.prod+"getVipByCarNoAndTime",
                precondition: "无",
                fitSystem: "路边停车车场及云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'carCode', info2: '是', info3: 'String', info4: '车牌编号' },
                        { info1: 'enterTime', info2: '是', info3: 'String', info4: '进场时间，yyyy-MM-dd HH:mm:ss' },
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'leaveTime', info2: '否', info3: 'String', info4: '出场时间，yyyy-MM-dd HH:mm:ss' },
                        { info1: 'channelId', info2: '否', info3: 'Long', info4: '通道id（云停车场必填）' },
                        { info1: 'areaId', info2: '否', info3: 'Long', info4: '区域id（云停车场必填）' },

                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'carCode', info2: '是', info3: 'String', info4: '车牌编号' },
                        { info1: 'channelIdList', info2: '否', info3: 'JSONArray', info4: '具有VIP权限的通道ID列表,空为整个车场都可以通行' },
                        { info1: 'customVipName', info2: '否', info3: 'String', info4: 'VIP类型名称' },
                        { info1: 'dynamicCarportNumber', info2: '否', info3: 'Integer', info4: '可用车位数' },
                        { info1: 'id', info2: '否', info3: 'Integer', info4: '唯一主键' },
                        { info1: 'isDynamicMode', info2: '是', info3: 'Integer', info4: '是否多位多车（0否，1是）' },
                        { info1: 'isPureTimeVip', info2: '否', info3: 'Integer', info4: '是否纯时间VIP（0否，1是）' },
                        { info1: 'monthTicketBillId', info2: '否', info3: 'Integer', info4: 'VIP票的ID' },
                        { info1: 'noVipCode', info2: '是', info3: 'Integer', info4: '进场说明（<url>参考附录:/Api/appendixData</url>）' },
                        { info1: 'openVipFullLimit', info2: '是', info3: 'Integer', info4: '是否开启VIP满位控制,0否,1是' },
                        { info1: 'remainDays', info2: '否', info3: 'Integer', info4: 'VIP票的剩余天数' },
                        { info1: 'timeperiodType', info2: '否', info3: 'Integer', info4: '时间段类型（0:时间有效期内，提醒期外,1:时间有效期内，提醒期内,2:时间有效期外，延时期内,3:时间有效期外，删除期内）' },
                        { info1: 'vipBillIsRemainCarport', info2: '是', info3: 'Integer', info4: 'VIP票是否有剩余车位（0否，1是）' },
                        { info1: 'vipFullOpenModel', info2: '否', info3: 'Integer', info4: 'VIP满位放行模式,0=系统有空位自动放行，无空位手动放行按VIP计费,1=系统有空位自动放行，无空位手动放行按临时车计费,2=系统无空位自动放行，按临时车计费' },
                        { info1: 'vipType', info2: '是', info3: 'Integer', info4: 'VIP类型组（0未定义，1临时车，2本地VIP，3外部VIP，4黑名单，5访客，6预订，7共享，8红名单）' },
                        { info1: 'vipTypeIsRemainCarport', info2: '是', info3: 'Integer', info4: 'VIP类型是否有剩余车位（0否，1是）' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/getVipByCarNoAndTime.vue